<template>
  <div>
    <div class="form-group row">
      <label for="eventType" class="col-lg-4 label-text">
        Event Type
      </label>
      <div class="col-lg-8">
        {{editEvent.eventTypeName}}
      </div>
    </div>
    <div class="form-group row">
      <label for="eventDate" class="col-lg-4 label-text">
        <span class="text-danger">*</span>Event Date
      </label>
      <div class="col-lg-8">
        <datepicker
          id="eventDate"
          :class="'flex-grow-1'"
          format="MM/dd/yyyy"
          input-class="form-control bg-white"
          :use-utc="false"
          :disabled-dates="disabledDateConfig.disabledDates"
          v-model="editEvent.date"
          @focusin.native="setEventDateIfNull"
          v-validate="{required: !isRequiredFromUpdate}"
          data-vv-as="Event Date"
          name='eventDate'
          :bootstrap-styling="true"
        >
          <div slot="afterDateInput" class="input-group-append">
            <span class="input-group-text">
              <font-awesome-icon icon="calendar-alt" />
            </span>
          </div>
        </datepicker>
        <div class="test-invalid">{{ errors.first('eventDate') }}</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="eventNotes" class="col-lg-4 label-text">
        Event Notes
      </label>
      <div class="col-lg-8">
        <textarea data-vv-as="Notes"
          type="textarea"
          class="form-control"
          name="notes"
          v-model="editEvent.Notes"
          placeholder="Enter Notes"
          rows="2"
          maxlength="256"
        />
          <small v-if="!errors.first('notes')" class="form-text text-muted">
            Max 256 characters
          </small>
          <div class="invalid-feedback">{{ errors.first('notes') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import EventDateHelper from '../../mixins/EventDateHelper';

function initialState() {
  return {
    serverError: null,
    disabledDateConfig: {
      disabledDates: {
        from: new Date(),
      },
    },
  };
}
export default {
  name: 'EventRequiredForm',
  components: {
    Datepicker,
  },
  mixins: [EventDateHelper],
  props: {
    editEvent: Object,
    isRequiredFromUpdate: Boolean,
  },
  // inject the parent validator
  inject: ['$validator'],
  data() {
    return initialState();
  },
  methods: {
    setEventDateIfNull() {
      if (this.editEvent.date === null) {
        this.editEvent.date = this.getEventDate();
      }
    },
  },
};
</script>
